import React, { useState } from "react";
import { XpHubModal } from "./XpHubModal";
import {
  XpCareerStatsRow,
  XP_STAT_BOX_BG_PROFILE,
  XP_STAT_BOX_GAP_PROFILE,
  XP_STAT_LABEL_CLASS_PROFILE,
  XP_WEEKLY_FINISHES_BOX_HEIGHT_PROFILE,
  XP_STAT_VALUE_CLASS,
} from "./XpCareerStatsRow";
import { XP_ICON_SRC, type XpSummary } from "../../utils/xp";
import { trackCtaClicked } from "../../utils/frontendTrackingEvents";

import { XP_WEEK_CROWN_ASSETS } from "./AvatarWithXpCrown";

type XpCareerSectionProps = {
  xp: XpSummary | null;
  /** When false, hide "My XP history" (e.g. viewing someone else's profile). */
  showHistoryLink?: boolean;
};

function FinishCrown({ src }: { src: string }) {
  return (
    <img src={src} alt="" className="mx-auto h-5 w-5 object-contain" loading="lazy" decoding="async" aria-hidden />
  );
}

export function XpCareerSection({ xp, showHistoryLink = true }: XpCareerSectionProps) {
  const [hubOpen, setHubOpen] = useState(false);
  const summary = xp ?? {
    total_xp: 0,
    week_xp: 0,
    week_rank: null,
    weekly_finishes: { first: 0, second: 0, third: 0 },
  };

  const openHub = () => {
    const pathname = typeof window !== "undefined" ? window.location.pathname : undefined;
    trackCtaClicked({
      cta_name: "xp_history",
      cta_location: "profile",
      source_page: pathname,
      pathname,
    });
    setHubOpen(true);
  };

  return (
    <>
      <div className="overflow-hidden border border-white/10">
        <div className="flex h-[26px] items-center gap-2 bg-[#5f2bb0] px-3">
          <img src={XP_ICON_SRC} alt="" className="h-4 w-4 shrink-0 object-contain" aria-hidden />
          <span className="min-w-0 flex-1 font-anton text-[12px] font-normal not-italic uppercase leading-[12px] tracking-[0%] text-white [leading-trim:none]">
            XP
          </span>
          {showHistoryLink ? (
            <button
              type="button"
              onClick={openHub}
              className="shrink-0 border-0 bg-transparent p-0 text-right font-chakra text-[10px] font-normal not-italic normal-case leading-[16px] tracking-[0%] text-[#D2FF00] hover:underline [leading-trim:none]"
            >
              My XP history
            </button>
          ) : null}
        </div>
        <div className={`flex flex-col ${XP_STAT_BOX_GAP_PROFILE}`}>
          <XpCareerStatsRow
            xp={xp}
            boxBgClassName={XP_STAT_BOX_BG_PROFILE}
            boxGapClassName={XP_STAT_BOX_GAP_PROFILE}
            statLabelClassName={XP_STAT_LABEL_CLASS_PROFILE}
            statValueClassName={XP_STAT_VALUE_CLASS}
            onLeaderboardClick={showHistoryLink ? openHub : undefined}
          />
          <div
            className={`flex ${XP_WEEKLY_FINISHES_BOX_HEIGHT_PROFILE} w-full flex-col items-center justify-center overflow-hidden px-2 py-0.5 ${XP_STAT_BOX_BG_PROFILE}`}
          >
            <p className="mb-0 shrink-0 text-center font-anton text-[9px] font-normal not-italic uppercase leading-[10px] tracking-[0%] text-white/40 [leading-trim:none]">
              Weekly XP leaderboard finishes
            </p>
            <div className="flex shrink-0 justify-center gap-5 text-center">
              <div className="flex flex-col items-center gap-0.5">
                <FinishCrown src={XP_WEEK_CROWN_ASSETS.gold} />
                <p className="font-anton text-[15px] font-normal not-italic uppercase leading-[100%] tracking-[0%] text-white [leading-trim:none]">
                  {summary.weekly_finishes.first}
                </p>
              </div>
              <div className="flex flex-col items-center gap-0.5">
                <FinishCrown src={XP_WEEK_CROWN_ASSETS.silver} />
                <p className="font-anton text-[15px] font-normal not-italic uppercase leading-[100%] tracking-[0%] text-white [leading-trim:none]">
                  {summary.weekly_finishes.second}
                </p>
              </div>
              <div className="flex flex-col items-center gap-0.5">
                <FinishCrown src={XP_WEEK_CROWN_ASSETS.bronze} />
                <p className="font-anton text-[15px] font-normal not-italic uppercase leading-[100%] tracking-[0%] text-white [leading-trim:none]">
                  {summary.weekly_finishes.third}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showHistoryLink ? (
        <XpHubModal isOpen={hubOpen} onClose={() => setHubOpen(false)} xp={xp} />
      ) : null}
    </>
  );
}
